export default "__VITE_ASSET__DuMv7YHT__"